/*============================================================================
  Pastille Diagnostic — apparition au scroll (HOME uniquement)

  Sur la home, la barre « Votre diagnostic par Magali Calmon » et la pastille
  poussaient le diagnostic EN MÊME TEMPS dès le haut de page. On masque la
  pastille tant que la barre est visible ; elle apparaît (fondu + glissé)
  une fois la barre sortie de l'écran au scroll. La barre reste le CTA en
  haut, la pastille prend le relais ensuite.

  - Logique par classe positive .is-revealed : par défaut, la pastille est
    cachée sur la home (cf. personal-shopper.css : body.template-index .ps-fab).
    On ajoute .is-revealed pour la montrer. Évite tout flash au chargement.
  - .is-revealed est distincte de .is-hidden (gérée par personal-shopper.js à
    l'ouverture du panel) et du masquage panier-ouvert -> aucun conflit.
  - Scoped à la home (body.template-index) pour ne rien changer ailleurs.
  - Marche desktop ET mobile (pas de bridage par largeur).
==============================================================================*/

(function () {
  'use strict';

  function init() {
    // Home uniquement
    if (!document.body.classList.contains('template-index')) return;

    var fab = document.getElementById('PSFab');
    if (!fab) return;

    var banner = document.querySelector('.personal-shopper-banner');

    function reveal() { fab.classList.add('is-revealed'); }
    function hide() { fab.classList.remove('is-revealed'); }

    hide(); // caché au chargement (état par défaut)

    if (banner && 'IntersectionObserver' in window) {
      // Barre visible -> pastille cachée ; barre sortie de l'écran -> pastille affichée
      new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) hide(); else reveal();
      }, { threshold: 0 }).observe(banner);
    } else {
      // Fallback (pas de barre ou pas d'IntersectionObserver) :
      // révéler après ~80% de la hauteur d'écran scrollée.
      var onScroll = function () {
        if (window.pageYOffset > window.innerHeight * 0.8) reveal();
        else hide();
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
